const TableActionTypes = {
  USER_ADDED: "ADMIN_USER_ADDED",
  USER_DELETED: "ADMIN_USER_DELETED",
};

export default TableActionTypes;
